(() => {
  'use strict';

  if (!window.customElements || customElements.get('upvc-product-support')) return;

  class UPVCProductSupport extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-upvc-product-support-link]');
      try {
        this.mappings = JSON.parse(this.querySelector('[data-upvc-product-support-data]').textContent);
        if (!Array.isArray(this.mappings)) throw new Error('Invalid support mapping');
      } catch (_) {
        this.mappings = [];
        this.showGuide(null);
        return;
      }

      this.scope = this.closest('product-hot-reload, .product--outer');
      if (!this.scope) return;

      // Empire's non-bubbling event fires before the hidden variant input is
      // updated. Read its detail and subscribe to the custom element itself.
      this.variantSelection = this.scope.querySelector('variant-selection');
      this.onVariantChange = (event) => {
        const detail = event.detail || {};
        this.showGuide(detail.state === 'selected' && detail.variant ? detail.variant.id : null);
      };
      this.variantSelection?.addEventListener('variant-change', this.onVariantChange);

      this.onOptionChange = (event) => {
        if (event.target.matches('[data-product-hot-reload-trigger], [data-variant-option], [data-variant-option-value]')) {
          // Until Empire resolves the new selection, no previous procedure is
          // safe to keep visible. A failed request leaves the guide hidden.
          this.showGuide(null);
        }
        if (event.target.matches('[data-variants][name="id"]')) this.showGuide(event.target.value);
      };
      this.scope.addEventListener('change', this.onOptionChange, true);

      // Section HTML replacements reconnect this element with a fresh mapping.
      // Do not infer a variant from a stale hidden input on initial connection.
      this.showGuide(this.dataset.selectedVariant);
    }

    disconnectedCallback() {
      this.variantSelection?.removeEventListener('variant-change', this.onVariantChange);
      this.scope?.removeEventListener('change', this.onOptionChange, true);
    }

    showGuide(id) {
      const guide = this.mappings?.find((mapping) => mapping && String(mapping.id) === String(id));
      let valid = false;
      if (id && guide && typeof guide.url === 'string' && typeof guide.title === 'string' && guide.title.trim()) {
        try {
          const url = new URL(guide.url, window.location.origin);
          valid = url.origin === window.location.origin && ['http:', 'https:'].includes(url.protocol) && url.pathname !== '/';
        } catch (_) { /* Invalid URL: omit the control. */ }
      }

      if (!this.link) {
        this.hidden = true;
        return;
      }
      this.hidden = !valid;
      this.link.hidden = !valid;
      if (valid) {
        this.link.href = guide.url;
        this.link.textContent = `Read the guide: ${guide.title}`;
      } else {
        this.link.removeAttribute('href');
        this.link.textContent = '';
      }
    }
  }

  customElements.define('upvc-product-support', UPVCProductSupport);
})();
